/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import { Link } from 'react-router-dom';

export const GradientLink = ({ to, text }: any) => {
  return (
    <Link
      to={to}
      className='flex justify-center px-6 py-2 rounded-full shadow-lg bg-gradient text-black focus:outline-none'
    >
      {text}
    </Link>
  );
};
